import React from 'react';
import { CopyOutlined } from '@ant-design/icons';

import { copyToClipboard } from "./_serverHelpers";

interface PropsInterface {
  value: string | undefined | null;
  /** Shortened form to render; falls back to the raw value. */
  display?: string;
  className?: string;
}

// Monospace value + copy icon. The full value always lands in the native
// tooltip so a truncated id stays readable without a click.
const _CopyValue = ({ value, display, className }: PropsInterface) => {
  if (!value) return <div>-</div>;

  return (
    <span className={`v-srv-copy ${className || ''}`}>
      <span className='o-value' title={value}>{display || value}</span>
      <CopyOutlined
        className='o-copy'
        title='Copy'
        onClick={() => copyToClipboard(value)}
      />
    </span>
  );
}

export default _CopyValue;
